import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { translate } from '../Services/translation';
import { Language } from './LanguageSelector';

const LanguageDropdown = (props: {
  languageList: Language;
  inline?: boolean;
}) => {
  const { languageList, inline = false } = props;
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const panelId = useRef(
    `language-dropdown-panel-${Math.random().toString(36).slice(2, 11)}`
  );

  useEffect(() => {
    if (!open) return;
    const onMouseDown = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setOpen(false);
        buttonRef.current?.focus();
      }
    };
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const options = languageList.LanguageList.filter(
    (language) => language.Name !== languageList.Name
  );

  return (
    <div className="language-dropdown relative" ref={rootRef}>
      <button
        ref={buttonRef}
        type="button"
        className="language-dropdown__trigger flex items-center gap-2"
        aria-expanded={open}
        aria-controls={panelId.current}
        aria-label={`${translate('header.select-language')}: ${
          languageList.Name
        }`}
        onClick={() => setOpen(!open)}
      >
        {languageList.Name}
        <i
          className={clsx(
            'fal fa-chevron-down text-[0.625em] transition-transform',
            open && 'rotate-180'
          )}
          aria-hidden="true"
        ></i>
      </button>
      <div className="invisible h-0 overflow-hidden" aria-hidden="true">
        {languageList.LanguageList.map((language) => (
          <div
            key={language.Url}
            className="language-dropdown__option flex items-center gap-2 whitespace-nowrap"
          >
            {language.Name}
            <i className="fal fa-chevron-down text-[0.625em]" aria-hidden="true"></i>
          </div>
        ))}
      </div>
      <ul
        id={panelId.current}
        className={clsx(
          'language-dropdown__panel',
          !open && 'hidden',
          !inline && 'absolute left-0 top-full min-w-full'
        )}
      >
        {options.map((language) => (
          <li key={language.Url}>
            <a className="language-dropdown__option block" href={language.Url}>
              {language.Name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageDropdown;
